import CatalogEditor from './CatalogEditor';

export default function CreateOffer() { return <CatalogEditor kind="offer" />; }
